var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('corp-tube',{attrs:{"contextInfo":_vm.contextInfo,"activeVideoId":_vm.videoId}})}
var staticRenderFns = []

export { render, staticRenderFns }